import { InjectionToken } from '@angular/core';
import { LoadingController } from '@ionic/angular';

export interface ResolverLoaderConfig {
	match?: (url: string) => boolean;
	message?: string;
	spinner?: any;
	delayMs?: number;
	minDurationMs?: number;
	includeLazyLoad?: boolean;
	/** Failsafe: auto-dismiss dopo X ms (default 10000) */
	hardStopMs?: number;
	/** Opzioni di ion-loading */
	loading?: Parameters<LoadingController['create']>[0];
}

export const RESOLVER_LOADER_CONFIG = new InjectionToken<ResolverLoaderConfig>('RESOLVER_LOADER_CONFIG');

/** Default senza "loading" (resta opzionale) */
export const DEFAULT_RESOLVER_LOADER_CONFIG: Required<Omit<ResolverLoaderConfig, 'loading'>> = {
	match: () => true,
	message: 'Caricamento…',
	spinner: 'circles',
	delayMs: 120,
	minDurationMs: 300,
	includeLazyLoad: true,
	hardStopMs: 10000,
};
